var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-center flex items-center justify-center w-full",style:({ height: _vm.height + 'px' })},[_c('feather-icon',{staticClass:"bx-spin",class:_vm.color,attrs:{"icon":"LoaderIcon","svgClasses":_vm.size}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }